import { render, staticRenderFns } from "./CorrespondenceLetterPreview.vue?vue&type=template&id=20f09b91&scoped=true"
import script from "./CorrespondenceLetterPreview.vue?vue&type=script&lang=js"
export * from "./CorrespondenceLetterPreview.vue?vue&type=script&lang=js"
import style0 from "./CorrespondenceLetterPreview.vue?vue&type=style&index=0&id=20f09b91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f09b91",
  null
  
)

export default component.exports